
import { getImageWebUrl } from "../../../utils/AppSetting";
import { MembershipType } from "../../../utils/Constants";
import { EditViewIndividualMemberData } from "../data/EditViewIndividualMember.Data";
import { handleEditFieldChange } from "./handleFieldChange";
export const setFieldParameter = (updatedFormData, allDropDownResponse, apiResponse) => {
    handleEditFieldChange(EditViewIndividualMemberData, allDropDownResponse, apiResponse);
    updatedFormData.initialState.membershipTypeId = apiResponse?.membershipType || null;
    updatedFormData.initialState.membershipNumber = apiResponse?.membershipNumber || null;
    updatedFormData.initialState.accountStatusId = apiResponse?.subscriptionStatusId || null;
    updatedFormData.initialState.reasonforLeavingId = null;
    updatedFormData.initialState.joiningDate = apiResponse?.accountJoinedDate ? new Date(apiResponse.accountJoinedDate) : null;
    updatedFormData.initialState.accountInformationUpdatedDate = apiResponse?.accountUpdatedAt ? new Date(apiResponse.accountUpdatedAt) : null
    updatedFormData.initialState.accountInformationUpdatedBy = apiResponse?.accountUpdatedBy ? new Date(apiResponse.accountUpdatedBy) : null
    updatedFormData.initialState.membershipTensureId = (apiResponse.membershipType === MembershipType.HONORARY_FELLO || apiResponse.membershipType === MembershipType.LIFEFELLOW) ? 4 : 1;
    updatedFormData.initialState.startDate = apiResponse?.subscriptionStartDate ? new Date(apiResponse.subscriptionStartDate) : null;
    updatedFormData.initialState.endDate = apiResponse?.subscriptionEndDate ? new Date(apiResponse.subscriptionEndDate) : null;
    updatedFormData.initialState.membershipSubcriptionUpdatedDate = apiResponse?.membershipUpdatedAt ? new Date(apiResponse.membershipUpdatedAt) : null;
    updatedFormData.initialState.membershipSubcriptionUpdatedBy = apiResponse?.membershipUpdatedBy || null;
    updatedFormData.initialState.isINSOLMembership = apiResponse?.isINSOLMembership ? "yes" : "no";
    updatedFormData.initialState.reasonId = Number(apiResponse?.insolMembershipReasonId) || 1;
    updatedFormData.initialState.firstName = apiResponse?.firstName || '';
    updatedFormData.initialState.salutationId = apiResponse?.salutationId || '';

    updatedFormData.initialState.lastName = apiResponse?.lastName || '';
    updatedFormData.initialState.displayName = apiResponse?.displayName || '';
    updatedFormData.initialState.DisplayPhoto = `${getImageWebUrl + apiResponse?.displayPhotoEncryptedName}` || '';
    updatedFormData.initialState.gender = apiResponse?.isGenderMale ? "male" : "female" || null;
    updatedFormData.initialState.dateofBirth = apiResponse?.dateOfBirth ? new Date(apiResponse.dateOfBirth) : null;
    updatedFormData.initialState.placeofBirth = Number(apiResponse?.placeOfBirthId) || '';
    updatedFormData.initialState.nationalityId = Number(apiResponse?.nationalityId) || null;
    updatedFormData.initialState.last4DigitsofNRIC = apiResponse?.nric || '';
    updatedFormData.initialState.workpass = apiResponse?.workpass || '';
    updatedFormData.initialState.mailingAddressLine1 = apiResponse?.addressLine1 || '';
    updatedFormData.initialState.mailingAddressLine2 = apiResponse?.addressLine2 || '';
    updatedFormData.initialState.mailingAddressLine3 = apiResponse?.addressLine3 || '';
    updatedFormData.initialState.countryId = Number(apiResponse?.countryId) || null;
    updatedFormData.initialState.postalCode = apiResponse?.postalCode || '';
    updatedFormData.initialState.emailAddress = apiResponse?.emailAddress || '';
    updatedFormData.initialState.mobile = apiResponse?.mobile || '';
    updatedFormData.initialState.highestQualificationId = Number(apiResponse?.highestQualificationAttained) || null;
    updatedFormData.initialState.highestQualificationOthers = apiResponse?.otherEducationInformation || ''
    updatedFormData.initialState.academicDegree = apiResponse?.degreeExaminationOrEquivalent || '';
    updatedFormData.initialState.awardingBody = apiResponse?.awardingBody || '';
    updatedFormData.initialState.otherQualifications = apiResponse?.otherQualification || '';
    updatedFormData.initialState.currentlyEmployed = apiResponse?.isCurrentlyEmployed ? "yes" : "no" || 'no';
    updatedFormData.initialState.organisationCompany = apiResponse?.organisationOrCompany || '';
    updatedFormData.initialState.jobTitle = apiResponse?.jobTitle || '';
    updatedFormData.initialState.jobRoleId = Number(apiResponse?.jobRoleId) || null;
    updatedFormData.initialState.bio = apiResponse?.bio || '';
    updatedFormData.initialState.organisationAddressLine1 = apiResponse?.organisationAddressLine1 || '';
    updatedFormData.initialState.organisationAddressLine2 = apiResponse?.organisationAddressLine2 || '';
    updatedFormData.initialState.organisationAddressLine3 = apiResponse?.organisationAddressLine3 || '';
    updatedFormData.initialState.empCountryId = Number(apiResponse?.employmentCountryId) || '';
    updatedFormData.initialState.empPostalCode = apiResponse?.employmentPostalCode || '';
    updatedFormData.initialState.empEmailAddress = apiResponse?.employmentEmailAddress || '';
    updatedFormData.initialState.empMobile = apiResponse?.employmentMobile || '';
    updatedFormData.initialState.linkdein = apiResponse.linkedIn || '';
    updatedFormData.initialState.isPublicAccountantRegACRA = apiResponse?.accountantRegisteredWithACRA || '';
    updatedFormData.initialState.isCharteredAccountant = apiResponse?.charteredAccountant || false;
    updatedFormData.initialState.isAdvocateAndSolicater = apiResponse?.advocateAndSolicitor || false;
    updatedFormData.initialState.isOtherProfessional = apiResponse?.isOtherProfessionalInformation || false;
    updatedFormData.initialState.isOtherProfessionalReason = apiResponse?.otherProfessionalInformation || false;
    updatedFormData.initialState.iscriminaloffence = apiResponse?.isCriminalOffence ? "yes" : "no" || 'no';
    updatedFormData.initialState.criminaloffenceMoreDetails = apiResponse?.criminalOffenceDetails || '';
    updatedFormData.initialState.isBenifitsOfYourCreditors = apiResponse?.isAdjudgedBankrupt ? "yes" : "no" || 'no';
    updatedFormData.initialState.benifitsOfYourCreditorsMoreDetails = apiResponse?.adjudgedBankruptDetails || '';
    updatedFormData.initialState.resumeWorkExpFile = apiResponse?.resumeUploadedName || null;
    updatedFormData.initialState.relevantDiplomasCertificatesFile = apiResponse?.diplomasCertificatesUploadedName || '';
    updatedFormData.initialState.detailedListAppRoleRespoFile = apiResponse?.roleResponsibilitiesFileUploadedName || '';
    updatedFormData.initialState.yearsOfRIExp = apiResponse?.yearsOfRIExperience === 0 ? '0' : apiResponse?.yearsOfRIExperience;
    updatedFormData.initialState.firstCharacterRefFile = apiResponse?.firstCharacterReferenceFileUploadedName || null;
    updatedFormData.initialState.secondCharacterRefFile = apiResponse?.secondCharacterReferenceFileUploadedName || null;
    updatedFormData.initialState.ReinstatementFile = apiResponse?.reinstatementFileUploadedName || null;
    updatedFormData.initialState.IsUpgradeApplications = apiResponse?.isUpgradeApplications || null;
    updatedFormData.initialState.academicDegreeOrEquivalent = apiResponse?.academicDegreeOrEquivalent || null
    updatedFormData.initialState.awardingBodyForStudent = apiResponse?.awardingBodyForStudent || null
     updatedFormData.initialState.expectedDate = apiResponse?.expectedDate ? new Date(apiResponse.expectedDate) : null;
    updatedFormData.initialState.relevantDiplomas = apiResponse?.relevantDiplomas || null;

    if (apiResponse?.isUpgradeApplications === true) {
        updatedFormData.section = updatedFormData.section.filter(
            (section) => section.title !== "INSOL Membership" && section.title !== "Communication" && section.title !== "Finance Record" && section.title !== "Events Bookings"
        );
    }
    if (apiResponse?.membershipType === MembershipType.ASSOCIATE) {
        updatedFormData.section = updatedFormData.section.filter(
            (section) => section.title !== "Character Reference"
        );
    }
    if (apiResponse?.membershipType === MembershipType.HONORARY_FELLO) {
        updatedFormData.section = updatedFormData.section.filter(
            (section) => (section.title !== "Finance Record" && section.title !== "INSOL Membership")
        );
        updatedFormData.section = updatedFormData.section.map((sec) => {
            let updatedFields = sec.fields.map((field) => {
                return field.id === "emailAddress" ? field : { ...field, validation: [] };
            })
            return { ...sec, fields: updatedFields }
        })
    }
    if (!apiResponse?.isReinstatementApplications) {
        updatedFormData.section = updatedFormData.section.filter(
            (section) => section.title !== "Reinstate File Section"
        );
    }
    updatedFormData.initialState.isSubscribeToMailList = apiResponse?.subscribeToMailingList || false;
    return updatedFormData
}



